import { useState } from 'react';
import { IFormikValues, IItemCheckBox, ITypeNature } from '../types';
import { SelectChangeEvent } from '@mui/material';
import { useFormik } from 'formik';
import {
  USER_TYPE,
  initialValues,
  listPermissions,
  optionsNature,
} from '../constants';
import userSchema from '../schema/userSchema';
import { useEditUser, usePostNewUser } from 'v2/resources/hooks/services/users';
import { useHistory } from 'react-router-dom';
import { IGetUsersResponse } from 'v2/resources/types/users';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';

const useUser = () => {
  const navigate = useHistory();
  const route = navigate.location;

  const { isMobile, isTablet } = useWindowSizes();
  const [typeNature, setTypeNature] = useState<ITypeNature>('pf');

  const user = (route?.state as { user?: IGetUsersResponse })?.user;
  const title = user ? 'Editar usuário' : 'Criar novo usuário';

  const fnSuccess = () => {
    navigate.replace('/users', {
      refresh: true,
    });
  };
  const fnError = () => {};

  const { mutate: mutateNewUser, isLoading: isLoadingNew } = usePostNewUser(
    fnSuccess,
    fnError
  );
  const { mutate: mutateEditUser, isLoading: isLoadingEdit } = useEditUser(
    fnSuccess,
    fnError
  );

  const formik = useFormik<IFormikValues>({
    initialValues: user
      ? {
          ...user,
        }
      : initialValues,
    validationSchema: userSchema,
    validateOnMount: true,
    onSubmit: () => handleSubmit(),
  });

  const handleTypeNature = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;

    setTypeNature(value as ITypeNature);
  };

  const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target;

    const valueFormatted: IItemCheckBox = JSON.parse(value);

    if (checked) {
      formik.setValues((prevState) => ({
        ...prevState,
        permissions: {
          ...prevState.permissions,
          [valueFormatted.value]: [
            ...prevState.permissions[valueFormatted.value],
            valueFormatted.item,
          ],
        },
      }));

      return;
    }

    formik.setValues((prevState) => ({
      ...prevState,
      permissions: {
        ...prevState.permissions,
        [valueFormatted.value]: prevState.permissions[
          valueFormatted.value
        ].filter((item) => item !== valueFormatted.item),
      },
    }));
  };

  const handleCheckSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target;

    if (!checked) {
      formik.setValues((prevState) => ({
        ...prevState,
        permissions: {
          ...prevState.permissions,
          [value]: [],
        },
      }));
      return;
    }

    const permissions =
      listPermissions
        .find((item) => item.value === value)
        ?.items.map((item) => item.value) || [];

    formik.setValues((prevState) => ({
      ...prevState,
      permissions: {
        ...prevState.permissions,
        [value]: [...permissions],
      },
    }));
  };

  const handleCheckSwitchActive = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { checked } = event.target;

    formik.setValues((prevState) => ({
      ...prevState,
      active: checked,
    }));
  };

  const handleSubmit = () => {
    if (user) {
      mutateEditUser({
        payload: { ...formik.values, active: !!formik.values.active },
        id: Number(user.id),
      });
      return;
    }
    mutateNewUser(formik.values);
  };
  return {
    optionsNature,
    typeNature,
    formik,
    listPermissions,
    isLoadingNew,
    isLoadingEdit,
    title,
    user,
    isMobile,
    isTablet,

    handleCheckSwitchActive,
    handleTypeNature,
    handleCheckbox,
    handleCheckSwitch,
    handleSubmit,
  };
};
export default useUser;
